import { v4 as uuidv4 } from 'uuid';
import { eLenderPaid } from '../../enums/eLenderPaid';
import { ICDV3ViewItem } from '../interfaces/ICDViewItem';

// Pick added to make it more obvious that this works and what it is doing.
//  (netted_out was incorrectly named nettedOut before, which is now impossible)
export const generateDefaultViewItem = (): Pick<ICDV3ViewItem, 'id' | 'created_at' | 'netted_out' | 'lender_paid'> => ({
  id: uuidv4(),
  created_at: new Date().toISOString(),
  netted_out: false,
  lender_paid: eLenderPaid.OtherNotSending,
});
